import {AsyncPipe} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatChipListbox, MatChipOption, MatChipRemove} from '@angular/material/chips';

import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatDivider} from '@angular/material/divider';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatIcon} from '@angular/material/icon';
import {MatInput} from '@angular/material/input';
import {MatTooltip} from '@angular/material/tooltip';
import {MarkdownTextareaComponent} from '@app/shared/markdown-textarea/markdown-textarea.component';
import {Stream} from '@app/stream/models';
import {StreamService} from '@app/stream/stream.service';
import {Tag} from '@app/tag/models';
import {FilterQuery, TagInputComponent} from '@app/tag/tag-input/tag-input.component';
import {TagService} from '@app/tag/tag.service';
import {UploadData, UploadService} from '@app/upload/upload.service';
import {Observable, of} from 'rxjs';

@Component({
    selector: 'frog-upload-detail-dialog',
    templateUrl: './upload-detail-dialog.component.html',
    styleUrls: ['./upload-detail-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MarkdownTextareaComponent,
        MatDivider,
        MatChipListbox,
        MatChipOption,
        MatIcon,
        MatChipRemove,
        TagInputComponent,
        MatCheckbox,
        MatTooltip,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        AsyncPipe,
    ],
})
export class UploadDetailDialogComponent implements OnInit {
    public form: FormGroup;
    public tags: Tag[];
    public previews: string[] | ArrayBuffer[];
    public stream$: Observable<any>;
    public loading: boolean;
    public slackLimit: number = 200;

    constructor(
        private streamService: StreamService,
        private uploadService: UploadService,
        private tagService: TagService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<UploadDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UploadData,
    ) {
        this.previews = [];
        this.tags = [];

        const uploadForms = this.data.uploadItems.map((uploadFile, index) => {
            this.readImage(index);
            return this.formBuilder.group({
                name: [uploadFile.name, Validators.required],
                description: '',
            });
        });

        this.form = this.formBuilder.group({
            uploads: this.formBuilder.array(uploadForms),
            group: data.asGroup,
        });
    }

    get uploads() {
        return this.form.controls['uploads'] as FormArray;
    }

    ngOnInit(): void {
        if (this.data.parentAssetId) {
            this.stream$ = of(new Stream());
        }
        else {
            this.stream$ = this.streamService.stream;
        }
    }

    readImage(index: number) {
        const reader = new FileReader();
        reader.readAsDataURL(this.data.uploadItems[index].file);
        reader.onload = (event) => {
            this.previews[index] = reader.result;
        };
    }

    save(stream: Stream) {
        this.loading = true;

        for (let i = 0; i < this.uploads.length; i++) {
            const item = this.data.uploadItems[i];
            const uploadForm = this.uploads.controls[i];
            item.name = uploadForm.value.name;
            item.description = uploadForm.value.description;
        }

        this.data.asGroup = this.form.value.group;
        this.data.tags = this.tags.map((tag) => tag.name);
        this.data.streamId = stream.id;

        this.uploadService.showUploadDialog();
        this.uploadService.upload(this.data)
            .subscribe();
        this.dialogRef.close();
    }

    removeTag(tag: Tag) {
        const index = this.tags.indexOf(tag);
        if (index >= 0) {
            this.tags.splice(index, 1);
        }
    }

    addTag(filterQuery: FilterQuery) {
        const parsedValue = filterQuery.value.replace(/"/g, '');
        this.tagService.resolveName(parsedValue).subscribe((tag) => {
            this.tags.push(tag);
        });
    }
}
